import { User } from './User';

export enum WebSessionCourseListName {
  Fav = 'Fav',
  Running = 'Running',
}

export type WebSessionCourseListItem = {
  Course: number[];
  DisplayOrder: number;
  Id: number;
  ListType: string;
  Name: WebSessionCourseListName;
  Value: string;
};

export type CourseArea = {
  Code: string;
  Color: string;
  Id: number;
  Name: string;
};

export type WebSession = {
  CurrentUser: User;
  CourseListOrder: WebSessionCourseListItem[];
  CourseAreas: CourseArea[];
};
